module.exports = __webpack_public_path__ + "img/not_found.681f4f56.svg";